import { useState } from 'react';
import { MANUAL_COMMAND_ERROR_MESSAGE } from '../utils/dashboardConstants';

/**
 * @typedef {Object} ActionHook
 * @property {boolean} showConfirm - Whether the confirmation dialog is open
 * @property {string} confirmTitle - Title to display in the confirmation dialog
 * @property {Function} handleClick - Opens the confirmation dialog
 * @property {Function} handleConfirm - Executes the action and closes the dialog
 * @property {Function} handleCancel - Closes the dialog without acting
 */

/**
 * Base hook for action flows that require a confirmation dialog before async dispatch.
 * @param {Function} getTitle - Returns the confirmation dialog title given current state
 * @param {Function} onConfirm - Async action to execute on confirmation
 * @param {Function} showToast - Error notification callback
 * @returns {ActionHook}
 */
export function useActionConfirm(getTitle, onConfirm, showToast) {
  const [showConfirm, setShowConfirm] = useState(false);

  const handleClick = () => setShowConfirm(true);
  const handleCancel = () => setShowConfirm(false);
  const handleConfirm = () => {
    setShowConfirm(false);
    setTimeout(async () => {
      try {
        await onConfirm();
      } catch (error) {
        console.error(error);
        showToast(MANUAL_COMMAND_ERROR_MESSAGE);
      }
    }, 0);
  };

  return { showConfirm, confirmTitle: getTitle(), handleClick, handleConfirm, handleCancel };
}
